import React from 'react';
import '../../App.css';
import About from '../WolvesPage';
import Footer from '../Footer';

function WolvesPage(){
    return(
        <>
            <About />
            <Footer />
        </>
        
    );
}

export default WolvesPage;